<div class="{{ loading ? 'iframe-hidden' : 'iframe-active' }}">
    <div
        id="container"
        class="container bg-white p-xs-0 px-sm-0 p-md-auto mt-2 pt-9 pb-6 pb-lg-7 {{
            componentClasses
        }}"
    >
        <div class="bentomatic">
            <iframe id="bento-iframe" [src]="_bentoLinkSafe"> </iframe>
        </div>
    </div>
</div>
<div class="pre-loader" *ngIf="loading">
    <app-preloader></app-preloader>
</div>
